export default {
  payablesBillList: {
    search: {
      payableInvoiceCompanyCode: '公司代码',
      companyCodePlaceholder: '请选择公司代码',
      companyNamePlaceholder: '请选择公司名称',
      payableInvoiceCompanyName: '公司名称',
      departmentCode: '部门组',
      departmentPlaceholde: '请选择部门组',
      invoiceUnitName: '开票单位',
      invoiceUnitPlaceholder: '请输入开票单位',
      domesticTotalAmount: '金额',
      currencyCode: '币种',
      invoiceCode: '发票编号',
      amountPlaceholder: '请输入',
      billNoPlaceholder: '请输入发票编号',
      payableInvoiceDepartmentCode: '部门',
      departPlaceholder: '请选择部门',
      salesContractNo: '销售合同号',
      salesContractPlaceholder: '请选择销售合同号',
      startPayableInvoiceCreateDate: '制单日期从',
      endPayableInvoiceCreateDate: '制单日期至',
      outboundCreateDatePlaceholder: '请选择日期',
      startPostDate: '入账日期从',
      endPostDate: '入账日期至',
      payableInvoiceStatus: '单据状态',
      documentStatusPlaceholder: '请选择单据状态',
      documentCode: '单据编号',
      documentNoPlaceholder: '请选择单据编号',
      batchSettleNo: '结算批次',
      settlementBatchPlaceholder: '请输入结算批次',
      postStatus: '入账状态',
      accountingStatusPlaceholder: '请输入入账状态',
      payableInvoiceCreatePerson: '制单人',
      outboundCreatePersonPlaceholder: '请选择制单人',
      invoiceType: '发票类型',
      invoiceTypePlaceholder: '请选择发票类型',
      accountingVoucher: '会计凭证',
      accountingVoucherPlaceholder: '请选择会计凭证',
      endDatePlaceholder: '请选择日期',
      purchaseContractNo: '采购合同号',
      procurementContractPlaceholder: '请输入采购合同',
      inboundBatchNo: '入库批次号',
      warehousingNoPlaceholder: '请输入入库批次号',
      salesLadingNo: '销售提单号',
      saleNoPlaceholder: '请输入销售提单号',
      departmentName: '部门',
      departmentNamePlaceholder: '请选择部门',
    },
    table: {
      payableInvoiceCompanyCode: '公司代码',
      payableInvoiceCompanyName: '公司名称',
      payableInvoiceDepartmentName: '部门',
      payableInvoiceStatus: '单据状态',
      invoiceType: '发票类型',
      invoiceCode: '发票编号',
      invoiceUnitName: '开票单位',
      postStatus: '入账状态',
      currencyCode: '币种',
      domesticTotalAmount: '本币总金额',
      domesticTotalWithoutTaxAmount: '本币不含税金额',
      domesticTaxAmount: '本币税额',
      originalTotalAmount: '原币总金额',
      originalTotalWithoutTaxAmount: '原币不含税金额',
      originalTaxAmount: '原币税额',
      postDate: '入账日期',
      payableInvoiceCreatePersonName: '制单人',
      payableInvoiceCreateDate: '制单日期',
    },
    form: {
      info: '基本信息',
      fee: '出库费用',
      goodInfo: '商品信息',
      transportInfo: '运输信息',
      outboundNo: '物流出库单号',
      outboundNoPlaceholder: '系统自动生成',
      outboundCreatePerson: '制单人',
      outboundStatus: '状态',
      companyName: '公司',
      departmentName: '部门',
      outboundCreateDate: '制单日期',
      outboundPrintTime: '出库提单打印',
      salesLadingNo: '销售提单号',
      salesLadingNoPlaceholder: '请输入调拨单号',
      allotNo: '调拨单号',
      allotNoPlaceholder: '请输入调拨单号',
      returnAndChangeNo: '退换货单号',
      returnAndChangeNoPlaceholder: '请输入退换货单号',
      deliveryMethod: '交货方式',
      deliveryMethodPlaceholder: '请选择交货方式',
      outboundCreateTime: '开单日期',
      outboundCreateTimePlaceholder: '请选择开单日期',
      validDateTo: '有效期至',
      validDateToPlaceholder: '请选择有效期至',
      contactPerson: '联系人',
      contactPersonPlaceholder: '请输入联系人',
      contactPhone: '联系方式',
      contactPhonePlaceholder: '请输入联系方式',
      outboundStorageNo: '出库仓库',
      outboundStorageNoPlaceholder: '请选择出库仓库',
      storageContactPhone: '仓库联系方式',
      storageContactPhonePlaceholder: '请输入仓库联系方式',
      outboundType: '出库类型',
      outboundTypePlaceholder: '请选择出库类型',
      customerNo: '客户名称',
      customerNoPlaceholder: '请选择客户',
      deliveryNote: '发货备注',
      deliveryNotePlaceholder: '请输入发货备注',
      checkbox1: '出库费物产月结',
      checkbox2: '出库费司机支付',
      checkbox3: '高温费物产月结',
      checkbox4: '补单',
      isIncludeOutboundExpense: '是否含出库费',
      fisIncludeOutboundExpensePlaceholder: '请选择',
      isSettled: '结算标识',
      outboundExpense: {
        expenseType: '费用类型',
        expenseTypePlaceholder: '请选择费用类型',
        expenseRate: '费率',
        expenseRatePlaceholder: '请输入费率',
        outboundQuantity: '数量',
        outboundQuantityPlaceholder: '请输入数量',
        outboundExpense: '费用',
        outboundExpensePlaceholder: '请输入费用',
      },
      good: {
        productNo: '商品编码',
        productName: '商品名称',
        productUnit: '单位',
        businessOrder: '业务指令',
        businessOrderQuantity: '业务指令数量',
        businessOrderPackage: '业务指令件数',
        storageShouldSend: '仓库应发',
        storageShouldSendQuantity: '仓库应发数量',
        storageShouldSendQuantityPlaceholder: '请输入仓库应发数量',
        storageShouldSendPackage: '仓库应发件数',
        storageShouldSendPackagePlaceholder: '请输入仓库应发件数',
        storageSend: '仓库实发',
        storageSendQuantity: '仓库实发数量',
        storageSendQuantityPlaceholder: '请输入仓库实发数量',
        storageSendPackage: '仓库实发件数',
        storageSendPackagePlaceholder: '请输入仓库实发数量',
        nameVoyageLicense: '船名航次',
        nameVoyageLicensePlaceholder: '请输入船名航次',
        warehouseReceiptsNo: '仓单号',
        warehouseReceiptsNoPlaceholder: '请输入仓单号',
        mark: '备注',
        markPlaceholder: '请输入备注',
      },
      shippingMethod: '运输方式',
      shippingMethodPlaceholder: '请选择运输方式',
      transport: {},
    },
    btnList: {
      add: '新增',
      del: '删除',
      save: '保存',
    },
  },
};
